// extracted by mini-css-extract-plugin
module.exports = {"main":"Activity_main__1vpGi","submain":"Activity_submain__2Vn-i","titleMain":"Activity_titleMain__2vF7V"};